import {
  FETCH_LIST_ERROR,
  FETCH_LIST_SUCCESS,
  FETCH_UPDATES_ERROR,
  FETCH_UPDATES_SUCCESS, REQUEST_LIST,
} from "../actions/actions";

export const MODEL_INFO ='infoTexts';
export const MODEL_PAGES = 'pages';
export const MODEL_CUSTOMERS = 'customers';
export const MODEL_SERVICES = 'services';
export const MODEL_PROJECTS = 'projects';

export const Models = [MODEL_INFO, MODEL_PAGES, MODEL_CUSTOMERS, MODEL_SERVICES, MODEL_PROJECTS];


const getInitialState = (state={}) => {
  state = {
    ...state,
    updates: {},
    lastUpdate: null,
    lastUpdateCheck: null,
    lastFetch: null,
    models: {},
    isFetchingList: false
  };
  for(const model of Models){
    state.models[model] = {}
  }
  return state;
};

const createObject = (list, name) => {
  let obj = {};
  let key = 'id';
  switch (name){
    case MODEL_INFO:
      key = 'code';
      break;
    case MODEL_PAGES:
      key = 'url';
      break;
    default:
      break;
  }
  for(let item of list){
    obj[item[key]] = item;
  }
  return obj;
};

export const getErrorMsg = (status, response) => {
  switch(status) {
    case 404:
      return response.error;
    case 500:
      return response.error;
    default:
      return 'hm, this is weird ... ';
  }
};

export function drf(state = {}, action) {
  if(Object.keys(state).length === 0){
    state = getInitialState(state)
  }
  switch (action.type) {
    case FETCH_UPDATES_SUCCESS: {
      return {
        ...state,
        lastUpdate: action.payload.lastUpdate,
        updates: action.payload.updates,
        lastUpdateCheck: Date.now().toISOString()
      }
    }
    case FETCH_UPDATES_ERROR: {
      return {
        ...state,
        error: getErrorMsg(action.payload.status, action.payload.response),
        isFetchingOverview: null,
      }
    }
    case REQUEST_LIST:
      return {
        ...state,
        isFetchingList: action.meta.name,
      };
    case FETCH_LIST_SUCCESS: {
      return {
        ...state,
        models: {
          ...state.models,
          [action.meta.name]: createObject(action.payload, action.meta.name)
        },
        isFetchingList: null
      }
    }
    case FETCH_LIST_ERROR: {
      return {
        ...state,
        error: getErrorMsg(action.payload.status, action.payload.response),
        isFetchingList: null,
      }
    }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/drfConnector.js